<template>
  <div class="content">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <crud-cadastro
        :loading="loading"
      >
        <v-card
          class="px-6 pt-4"
          style="margin-top: 14px; border-radius: 16px"
          outlined
        >
          <v-card-title
            class="pa-0"
            style="text-shadow: grey 0.1em 0.1em 0.2em;"
          >
            Dados
          </v-card-title>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="descricao"
                label="Descrição*"
                :rules="[rules.required, rules.maxLength(255)]"
                maxlength="255"
                required
                validate-on-blur
                outlined
                rounded
                dense
              />
            </v-col>
          </v-row>
        </v-card>
        <v-row
          class="pa-3"
          justify="center"
          justify-sm="end"
        >
          <v-btn
            class="text-none text-white mr-3"
            color="error"
            rounded
            @click="$router.push({ path: `/${$user.get().role}/setores/` })"
          >
            <v-icon
              dark
              left
            >
              mdi-minus-circle
            </v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="desabilitaBotao"
            class="text-none text-white"
            rounded
            @click="submitForm"
          >
            <v-icon
              dark
              left
            >
              mdi-checkbox-marked-circle
            </v-icon>
            Salvar
          </v-btn>
        </v-row>
      </crud-cadastro>
    </v-form>
  </div>
</template>
<script>
  import rules from '../../utils/formRules'
  import { mapFields } from 'vuex-map-fields'
  import SetorFormStore, { BOOTSTRAP_PROFILE, SUBMIT } from '@/store/modules/forms/setor'
  import { mapState, mapActions } from 'vuex'
  export default {
    data () {
      return {
        valid: false,
        rules: rules,
        // descricao: '',
      }
    },
    computed: {
      ...mapState('form/setor', ['loading', 'isEditing']),
      ...mapFields('form', [
        'data.descricao',
      ]),

      desabilitaBotao () {
        return this.loading || !this.valid
      },
    },
    created () {
      if (!this.$store.state.form.setor) { this.$store.registerModule(['form', 'setor'], SetorFormStore) }
      const id = this.$route.query.id
      this.BOOTSTRAP_PROFILE({ id })
    },
    methods: {
      ...mapActions('form/setor', [BOOTSTRAP_PROFILE, SUBMIT]),
      submitForm () {
        if (!this.$refs.form.validate()) {
          return null
        }
        this.SUBMIT({ router: this.$router, user: this.$user })
      },
    },
  }
</script>
